import React from 'react'
import RecordForm from '../../../../../../generic/universal-table/components/RecordForm/RecordForm'
import { ProductUiRow } from '../types/productTable.types'

type ProductFormProps = React.ComponentProps<typeof RecordForm<ProductUiRow>>

// Thin module-named wrapper so AppModal has a stable `Children` seam (and a place for
// any future product-specific glue). All logic lives in the unified RecordForm.
const ProductForm = (props: ProductFormProps) => <RecordForm<ProductUiRow> {...props} />

export default ProductForm
